<popup-header [materialTitleIcon]="'content_copy'"
              (clickAction)="cancelAction()"
              [text]="data?.title || 'Sensor Data Export'">
</popup-header>

<div mat-dialog-content [formGroup]="fgExportData">
    <div *ngIf="data?.displayDateRange">
        <mat-form-field appearance="fill">
            <mat-label>Enter Start/End Date</mat-label>
            <mat-date-range-input [rangePicker]="picker">
                <input matStartDate placeholder="Start date" formControlName="startDate">
                <input matEndDate placeholder="End date" formControlName="endDate">
            </mat-date-range-input>
            <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
            <mat-error *ngIf="fgExportData.controls.startDate.hasError('matStartDateInvalid')">Invalid start date
            </mat-error>
            <mat-error *ngIf="fgExportData.controls.endDate.hasError('matEndDateInvalid')">Invalid end date
            </mat-error>
        </mat-form-field>
    </div>
    <br>
    <mat-radio-group aria-label="Select an option" formControlName="exportType">
        <mat-radio-button value="points">Points</mat-radio-button>
        <mat-radio-button value="ranges">Ranges</mat-radio-button>
    </mat-radio-group>
</div>

<popup-button-container>
    <cas-button [color]="null" (clickAction)="cancelAction()" [btnText]="'Cancel'"></cas-button>
    <cas-button [disabled]="!fgExportData.valid" (clickAction)="confirmAction()" [btnText]="'Export'"></cas-button>
</popup-button-container>
